import { PageLink } from "../../../_start/layout/core";

export const settingsSubmenu: Array<PageLink> = [
	{
		title: "SEO",
		path: "/settings/seo",
		isActive: true,
	},
];
